module.exports = __webpack_public_path__ + "static/media/App-Store-Button_resize.60c73bb8.webp";